import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '#environments/environment';
import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root'})
export class UserCountService {
  constructor(private httpClient : HttpClient) {
  }

  public Query(query): Observable<any>  {
    let params = new HttpParams();
    params = query.projectObjectId ? params.append('projectObjectId', query.projectObjectId) : params;
    params = query.dataUptoHours ? params.append('dataUptoHours', query.dataUptoHours) : params;
  

    const response = this.httpClient.get(`${environment.apiEndpoint}/user/UserCount`, { params: params});
    return response;
  }


}

